import ManufacturerList from './ManufacturerList';

export default ManufacturerList;
export * from './ManufacturerList';
